import { render } from "./AutoCalificaFeedbackNew.vue?vue&type=template&id=5d41ca8d&scoped=true"
import script from "./AutoCalificaFeedbackNew.vue?vue&type=script&lang=js"
export * from "./AutoCalificaFeedbackNew.vue?vue&type=script&lang=js"

import "./AutoCalificaFeedbackNew.vue?vue&type=style&index=0&id=5d41ca8d&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d41ca8d"]])

export default __exports__